(function () {
  'use strict';

  // =====================================================
  // SETTINGS
  // =====================================================

  const BYOB_ATTRIBUTION = 'Rebuy Bundle Builder';

  // Check cart every 2 seconds
  const CHECK_INTERVAL = 2000;


  // =====================================================
  // VARIABLES
  // =====================================================

  let byobActive = false;
  let checking = false;
  let removing = false;
  let cleaningPromise = null;
  let checkoutProcessing = false;

  // Performance controls
  let upsellHideTimer = null;
  let cartCheckTimer = null;
  let cartCheckQueued = false;


  // =====================================================
  // CHECK IF ITEM IS BYOB
  // =====================================================

  function isBYOBItem(item) {

    return !!(
      item &&
      item.properties &&
      item.properties._attribution === BYOB_ATTRIBUTION
    );

  }


  // =====================================================
  // GET CART
  // =====================================================

  async function getCart() {

    const response = await fetch(
      '/cart.js',
      {
        cache: 'no-store'
      }
    );

    if (!response.ok) {

      throw new Error(
        'Cart request failed: ' + response.status
      );

    }

    return await response.json();

  }


  // =====================================================
  // SHOW MESSAGE
  // =====================================================

  function showBYOBMessage(messageText) {

    let message =
      document.getElementById(
        'byob-cart-lock-message'
      );

    if (!message) {

      message =
        document.createElement('div');

      message.id =
        'byob-cart-lock-message';

      document.documentElement.appendChild(
        message
      );

      Object.assign(
        message.style,
        {

          position: 'fixed',

          top: '50%',
          left: '50%',

          transform:
            'translate(-50%, -50%)',

          zIndex:
            '2147483647',

          background:
            '#ffffff',

          color:
            '#006f62',

          padding:
            '14px 20px',

          borderRadius:
            '8px',

          boxShadow:
            '0 4px 25px rgba(0,0,0,0.25)',

          fontSize:
            '14px',

          fontWeight:
            '600',

          maxWidth:
            '90%',

          width:
            'max-content',

          textAlign:
            'center',

          lineHeight:
            '1.4',

          opacity:
            '0',

          visibility:
            'hidden',

          transition:
            'opacity .2s ease, visibility .2s ease',

          pointerEvents:
            'none',

          boxSizing:
            'border-box'

        }
      );

    }

    message.textContent =
      messageText;

    message.style.visibility =
      'visible';

    message.style.opacity =
      '1';

    clearTimeout(
      message._hideTimer
    );

    message._hideTimer =
      setTimeout(
        function () {

          message.style.opacity =
            '0';

          message.style.visibility =
            'hidden';

        },
        3000
      );

  }


  // =====================================================
  // HIDE GOKWIK UPSELL
  // =====================================================

  function hideGoKwikUpsell() {

    if (!byobActive) {
      return;
    }


    // FAST PATH
    const existingHidden =
      document.querySelector(
        '[data-byob-gokwik-hidden="true"]'
      );

    if (existingHidden) {

      existingHidden.style.setProperty(
        'display',
        'none',
        'important'
      );

      existingHidden.style.setProperty(
        'visibility',
        'hidden',
        'important'
      );

      existingHidden.style.setProperty(
        'pointer-events',
        'none',
        'important'
      );

      return;
    }


    // FIND POSSIBLE UPSELL SECTION
    const candidates =
      document.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, p, span, div'
      );


    for (const element of candidates) {

      if (
        !element ||
        element.children.length > 20
      ) {

        continue;

      }


      const text =
        (
          element.innerText ||
          element.textContent ||
          ''
        )
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();


      if (
        text !== 'you may also like'
      ) {

        continue;

      }


      // FIND PARENT CONTAINER
      let current =
        element;

      let bestContainer =
        null;


      for (
        let i = 0;
        i < 8;
        i++
      ) {

        if (
          !current.parentElement
        ) {

          break;

        }


        current =
          current.parentElement;


        const buttons =
          current.querySelectorAll(
            'button, a'
          );


        let addButtonCount =
          0;


        for (
          const button of buttons
        ) {

          const buttonText =
            (
              button.innerText ||
              button.textContent ||
              button.value ||
              ''
            )
              .replace(/\s+/g, ' ')
              .trim()
              .toLowerCase();


          if (
            buttonText === '+ add' ||
            buttonText.includes('+ add')
          ) {

            addButtonCount++;

          }

        }


        if (
          addButtonCount > 0
        ) {

          bestContainer =
            current;

        }


        if (
          current === document.body ||
          current === document.documentElement
        ) {

          break;

        }

      }


      if (!bestContainer) {
        continue;
      }


      // HIDE SECTION
      bestContainer.setAttribute(
        'data-byob-gokwik-hidden',
        'true'
      );


      bestContainer.style.setProperty(
        'display',
        'none',
        'important'
      );

      bestContainer.style.setProperty(
        'visibility',
        'hidden',
        'important'
      );

      bestContainer.style.setProperty(
        'height',
        '0',
        'important'
      );

      bestContainer.style.setProperty(
        'max-height',
        '0',
        'important'
      );

      bestContainer.style.setProperty(
        'min-height',
        '0',
        'important'
      );

      bestContainer.style.setProperty(
        'overflow',
        'hidden',
        'important'
      );

      bestContainer.style.setProperty(
        'opacity',
        '0',
        'important'
      );

      bestContainer.style.setProperty(
        'pointer-events',
        'none',
        'important'
      );


      console.log(
        '🚫 GoKwik upsell hidden — BYOB active'
      );

      return;

    }

  }


  // =====================================================
  // RESTORE GOKWIK UPSELL
  // =====================================================

  function restoreGoKwikUpsell() {

    document
      .querySelectorAll(
        '[data-byob-gokwik-hidden="true"]'
      )
      .forEach(
        function (element) {

          element.style.removeProperty(
            'display'
          );

          element.style.removeProperty(
            'visibility'
          );

          element.style.removeProperty(
            'height'
          );

          element.style.removeProperty(
            'max-height'
          );

          element.style.removeProperty(
            'min-height'
          );

          element.style.removeProperty(
            'overflow'
          );

          element.style.removeProperty(
            'opacity'
          );

          element.style.removeProperty(
            'pointer-events'
          );

          element.removeAttribute(
            'data-byob-gokwik-hidden'
          );

        }
      );

  }


  // =====================================================
  // MUTATION OBSERVER
  // =====================================================

  const upsellObserver =
    new MutationObserver(
      function () {

        if (!byobActive) {
          return;
        }

        clearTimeout(
          upsellHideTimer
        );

        upsellHideTimer =
          setTimeout(
            function () {

              hideGoKwikUpsell();

            },
            250
          );

      }
    );


  upsellObserver.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  // =====================================================
  // INTERCEPT FETCH CART ADD
  // =====================================================

  const originalFetch =
    window.fetch;


  window.fetch =
    async function () {

      const args =
        Array.from(arguments);

      const request =
        args[0];

      let url =
        '';


      if (
        typeof request === 'string'
      ) {

        url =
          request;

      } else if (
        request &&
        request.url
      ) {

        url =
          request.url;

      }


      const isCartAdd =
        url.includes('/cart/add');


      // =================================================
      // BYOB ACTIVE + NORMAL CART ADD
      // =================================================

      if (
        byobActive &&
        isCartAdd
      ) {

        console.log(
          '🚫 CART ADD BLOCKED — BYOB ACTIVE'
        );


        showBYOBMessage(
          'This product can’t be added while building your own bundle (BYOB).'
        );


        return new Response(

          JSON.stringify({

            status:
              'blocked',

            message:
              'BYOB cart lock active'

          }),

          {

            status:
              200,

            headers: {

              'Content-Type':
                'application/json'

            }

          }

        );

      }


      return originalFetch.apply(
        this,
        args
      );

    };


  // =====================================================
  // INTERCEPT XHR CART ADD
  // =====================================================

  const originalOpen =
    XMLHttpRequest.prototype.open;

  const originalSend =
    XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open =
    function (
      method,
      url
    ) {

      this._byobRequestURL =
        url || '';

      return originalOpen.apply(
        this,
        arguments
      );

    };


  XMLHttpRequest.prototype.send =
    function () {

      const url =
        this._byobRequestURL ||
        '';


      if (
        byobActive &&
        url.includes('/cart/add')
      ) {

        console.log(
          '🚫 XHR CART ADD BLOCKED — BYOB ACTIVE'
        );


        showBYOBMessage(
          'This product can’t be added while building your own bundle (BYOB).'
        );


        this.abort();

        return;

      }


      return originalSend.apply(
        this,
        arguments
      );

    };


  // =====================================================
  // QUEUED CART CHECK
  // =====================================================

  function queueCartCheck(
    delay = 0
  ) {

    if (cartCheckQueued) {
      return;
    }


    cartCheckQueued =
      true;


    clearTimeout(
      cartCheckTimer
    );


    cartCheckTimer =
      setTimeout(
        async function () {

          cartCheckQueued =
            false;

          await checkBYOB();

        },
        delay
      );

  }


  // =====================================================
  // CHECK BYOB STATUS
  // =====================================================

  async function checkBYOB() {

    if (checking) {
      return;
    }


    checking =
      true;


    try {

      const cart =
        await getCart();


      const hasBYOB =
        cart.items.some(
          function (item) {

            return isBYOBItem(
              item
            );

          }
        );


      byobActive =
        hasBYOB;


      // =================================================
      // BYOB ACTIVE
      // =================================================

      if (byobActive) {

        hideGoKwikUpsell();

        // IMPORTANT:
        // If normal products were already in the cart
        // before BYOB was added, remove them immediately.
        await cleanCart();

      } else {

        restoreGoKwikUpsell();

      }


      // =================================================
      // LOCK NORMAL ADD BUTTONS
      // =================================================

      document
        .querySelectorAll(

          'form[action*="/cart/add"] button[type="submit"], ' +

          'form[action*="/cart/add"] input[type="submit"], ' +

          'button[name="add"]'

        )
        .forEach(
          function (button) {


            // NEVER TOUCH REBUY

            if (
              button.closest(
                '.rebuy-widget'
              ) ||

              button.closest(
                '[data-rebuy]'
              )
            ) {

              return;

            }


            if (byobActive) {

              button.setAttribute(
                'data-byob-locked',
                'true'
              );

            } else {

              button.removeAttribute(
                'data-byob-locked'
              );

            }

          }
        );


    } catch (error) {

      console.error(
        'BYOB check error:',
        error
      );

    } finally {

      checking =
        false;

    }

  }


  // =====================================================
  // BLOCK NORMAL PRODUCT CLICK
  // =====================================================

  document.addEventListener(
    'click',
    function (event) {

      if (!byobActive) {
        return;
      }


      const button =
        event.target.closest(

          'form[action*="/cart/add"] button[type="submit"], ' +

          'form[action*="/cart/add"] input[type="submit"], ' +

          'button[name="add"]'

        );


      if (!button) {
        return;
      }


      // NEVER BLOCK REBUY

      if (
        button.closest(
          '.rebuy-widget'
        ) ||

        button.closest(
          '[data-rebuy]'
        )
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      showBYOBMessage(
        'This bundle can’t be added to the cart while building your own bundle (BYOB).'
      );


      console.log(
        '🚫 NORMAL PRODUCT CLICK BLOCKED'
      );

    },
    true
  );


  // =====================================================
  // BLOCK NORMAL FORM SUBMIT
  // =====================================================

  document.addEventListener(
    'submit',
    function (event) {

      if (!byobActive) {
        return;
      }


      const form =
        event.target;


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {

        return;

      }


      // NEVER BLOCK REBUY

      if (
        form.closest(
          '.rebuy-widget'
        ) ||

        form.closest(
          '[data-rebuy]'
        )
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      showBYOBMessage(
        'This bundle can’t be added to the cart while building your own bundle (BYOB).'
      );


      console.log(
        '🚫 NORMAL FORM SUBMIT BLOCKED'
      );

    },
    true
  );


  // =====================================================
  // CLEAN ALL NON-BYOB PRODUCTS
  // =====================================================

  async function cleanCart() {

    if (cleaningPromise) {

      return cleaningPromise;

    }


    cleaningPromise =
      (async function () {

        if (removing) {
          return;
        }


        removing =
          true;


        try {

          let cart =
            await getCart();


          // =================================================
          // WAIT FOR REBUY BYOB TO APPEAR
          // =================================================
          //
          // Rebuy can take a few seconds to finish adding
          // the BYOB item to Shopify's cart.

          let attempts =
            0;


          while (
            !cart.items.some(
              function (item) {

                return isBYOBItem(
                  item
                );

              }
            ) &&
            attempts < 50
          ) {

            await new Promise(
              function (resolve) {

                setTimeout(
                  resolve,
                  100
                );

              }
            );


            cart =
              await getCart();


            attempts++;

          }


          // =================================================
          // CHECK BYOB
          // =================================================

          const hasBYOB =
            cart.items.some(
              function (item) {

                return isBYOBItem(
                  item
                );

              }
            );


          if (!hasBYOB) {

            return;

          }


          byobActive =
            true;


          hideGoKwikUpsell();


          // =================================================
          // FIND EVERYTHING THAT IS NOT BYOB
          // =================================================

          const itemsToRemove =
            cart.items.filter(
              function (item) {

                return !isBYOBItem(
                  item
                );

              }
            );


          if (
            !itemsToRemove.length
          ) {

            console.log(
              '✅ BYOB CART CLEAN'
            );

            return;

          }


          console.log(
            '🚫 NON-BYOB ITEMS FOUND:',
            itemsToRemove
          );


          showBYOBMessage(
            'Existing cart products will be removed because you are building your own bundle.'
          );


          // =================================================
          // REMOVE NON-BYOB ITEMS SEQUENTIALLY
          // =================================================
          //
          // Sequential requests are safer than firing several
          // /cart/change.js requests at the same time.

          for (const item of itemsToRemove) {

            console.log(
              '🗑️ Removing:',
              item.title
            );


            try {

              const response =
                await fetch(
                  '/cart/change.js',
                  {

                    method:
                      'POST',

                    headers: {

                      'Content-Type':
                        'application/json',

                      'Accept':
                        'application/json'

                    },

                    body:
                      JSON.stringify({

                        id:
                          item.key,

                        quantity:
                          0

                      })

                  }
                );


              if (!response.ok) {

                console.warn(
                  '⚠️ Failed to remove cart item:',
                  item.title,
                  response.status
                );

              }

            } catch (error) {

              console.error(
                '❌ Error removing cart item:',
                item.title,
                error
              );

            }

          }


          console.log(
            '✅ ALL NON-BYOB PRODUCTS REMOVED'
          );


          // =================================================
          // VERIFY
          // =================================================

          for (
            let i = 0;
            i < 20;
            i++
          ) {

            const verifyCart =
              await getCart();


            const remaining =
              verifyCart.items.filter(
                function (item) {

                  return !isBYOBItem(
                    item
                  );

                }
              );


            if (
              remaining.length === 0
            ) {

              console.log(
                '✅ BYOB CART VERIFIED CLEAN'
              );

              break;

            }


            await new Promise(
              function (resolve) {

                setTimeout(
                  resolve,
                  100
                );

              }
            );

          }


        } catch (error) {

          console.error(
            'BYOB cart cleaning error:',
            error
          );

        } finally {

          removing =
            false;

          cleaningPromise =
            null;

        }

      })();


    return cleaningPromise;

  }


  // =====================================================
  // PROTECT CART
  // =====================================================

  async function protectCart() {

    try {

      const cart =
        await getCart();


      const hasBYOB =
        cart.items.some(
          function (item) {

            return isBYOBItem(
              item
            );

          }
        );


      // =================================================
      // NO BYOB
      // =================================================

      if (!hasBYOB) {

        byobActive =
          false;


        restoreGoKwikUpsell();


        return;

      }


      // =================================================
      // BYOB ACTIVE
      // =================================================

      byobActive =
        true;


      hideGoKwikUpsell();


      // =================================================
      // CHECK FOR ANY OTHER PRODUCT
      // =================================================

      const hasNonBYOB =
        cart.items.some(
          function (item) {

            return !isBYOBItem(
              item
            );

          }
        );


      if (hasNonBYOB) {

        await cleanCart();

      }


    } catch (error) {

      console.error(
        'BYOB protection error:',
        error
      );

    }

  }


  // =====================================================
  // CHECKOUT DETECTION
  // =====================================================

  function isCheckoutButton(element) {

    if (!element) {
      return false;
    }


    const button =
      element.closest(
        'button, a, input'
      );


    if (!button) {
      return false;
    }


    const text =
      (
        button.innerText ||
        button.textContent ||
        button.value ||
        button.getAttribute(
          'aria-label'
        ) ||
        ''
      )
        .trim()
        .toLowerCase();


    const href =
      (
        button.getAttribute(
          'href'
        ) ||
        ''
      )
        .toLowerCase();


    return (
      text.includes('checkout') ||
      href.includes('/checkout')
    );

  }


  // =====================================================
  // CHECKOUT PROTECTION
  // =====================================================

  document.addEventListener(
    'click',
    async function (event) {

      if (!byobActive) {
        return;
      }


      if (
        !isCheckoutButton(
          event.target
        )
      ) {

        return;

      }


      // =================================================
      // IF CLEANUP IS RUNNING
      // =================================================

      if (
        removing ||
        cleaningPromise
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        if (checkoutProcessing) {
          return;
        }


        checkoutProcessing =
          true;


        showBYOBMessage(
          'Please wait while we update your cart.'
        );


        try {

          await cleanCart();


          const finalCart =
            await getCart();


          const remaining =
            finalCart.items.filter(
              function (item) {

                return !isBYOBItem(
                  item
                );

              }
            );


          if (
            remaining.length === 0
          ) {

            console.log(
              '✅ CART CLEAN — CONTINUING CHECKOUT'
            );


            window.location.href =
              '/checkout';

          } else {

            console.warn(
              '⚠️ Non-BYOB products still remain.'
            );

          }


        } catch (error) {

          console.error(
            'Checkout protection error:',
            error
          );

        } finally {

          checkoutProcessing =
            false;

        }

      }

    },
    true
  );


  // =====================================================
  // START
  // =====================================================

  // Immediate BYOB status check
  queueCartCheck(0);


  // Give Rebuy time to initialize
  setTimeout(
    protectCart,
    250
  );


  // =====================================================
  // SAFETY CHECK
  // =====================================================

  setInterval(
    function () {

      queueCartCheck(0);

    },
    CHECK_INTERVAL
  );


  // =====================================================
  // INITIAL GOKWIK CHECKS
  // =====================================================

  setTimeout(
    hideGoKwikUpsell,
    700
  );


  setTimeout(
    hideGoKwikUpsell,
    1500
  );


  setTimeout(
    hideGoKwikUpsell,
    2500
  );


  // =====================================================
  // COMPLETE
  // =====================================================

  console.log(
    '======================================'
  );

  console.log(
    '✅ BYOB CART LOCK ACTIVE'
  );

  console.log(
    '✅ NON-BYOB PRODUCT PROTECTION ACTIVE'
  );

  console.log(
    '✅ EXISTING CART PRODUCTS AUTO-REMOVE ACTIVE'
  );

  console.log(
    '✅ GOKWIK UPSELL PROTECTION ACTIVE'
  );

  console.log(
    '✅ CHECKOUT PROTECTION ACTIVE'
  );

  console.log(
    '⚡ BYOB PERFORMANCE OPTIMIZATION ACTIVE'
  );

  console.log(
    '======================================'
  );

})();